




import Vue from 'vue';

export default Vue.extend({
  props: {
    currency: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    formatted(): string {
      const amount = (this.amount / 100).toFixed(2);
      return `$${amount} ${this.currency.toUpperCase()}`;
    },
  },
});
